"use strict";
(self["webpackChunkhypotheken_huismap_asn"] = self["webpackChunkhypotheken_huismap_asn"] || []).push([[23],{

/***/ 3023
(module) {

module.exports = /*#__PURE__*/JSON.parse('{"huismap.title":{"default":"Welkom bij de Huismap"},"huismap.intro":{"default":"Dit is je persoonlijke omgeving waar je je gegevens deelt met je ASN-adviseur. Wil je dit minstens 2 dagen voor je gesprek invullen? Dan kan de adviseur zich goed voorbereiden op jullie gesprek."},"huismap.intro-info":{"default":"Informatie over het aanmaken van de toegangsnaam en wachtwoord vind je in de e-mail die je van ons hebt ontvangen."},"huismap.login-button":{"default":"Inloggen"},"huismap.forgot-username-button":{"default":"Login aanmaken met Huismapcode"},"huismap.login-url":{"default":"/online/web/onlinebankieren/inloggen/?huismap="},"huismap.prospect-digicode.username-forgot-url":{"default":"/hypotheek/hypotheekadvies/toegang-aanvragen-huismap.html"}}');

/***/ }

}]);